import React, { useState } from "react";
import { toast } from "react-toastify";
import { resetPassword } from "../../services/data/auth";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const ForgotPasswordModal = ({ show, onClose, loginId}) => {
    
  const [showNewPassword, setShowNewPassword] = useState(true);
  const [showConfirmPassword, setShowConfirmPassword] = useState(true);

  const[initialValues, setInitialValues] = useState({
    // username:"",
    newpwd:"",
    cpassword:""
  })
  
  const handleChange =(e)=>{
    const {name, value} = e.target
    setInitialValues((prev)=>(
      {
        ...prev,
        [name]:value
      })
    )
  }

  const handleSubmit = async()=>{
    // if(!initialValues?.username){
    //   toast.error("Enter the UserName")
    // }else 
    if(!initialValues?.newpwd){
      toast.error("Enter the Newpassword")
    }else if(!initialValues?.cpassword){
      toast.error("Enter the Confirmpassword")
    }else if(initialValues.newpwd.trim() !== initialValues.cpassword.trim()){
      toast.error("New password and confirm password do not match.")
    }else{
      const payload = {
        username:loginId,
        newpwd:initialValues?.newpwd.trim(),
      }
      await resetPassword(payload).then((response)=>{
        if(response?.data?.status === 'success'){
          toast.success(response?.data?.message)
          onClose()
        }else{
          toast.error(response?.data?.message)
        }
      })
      .catch((err)=>{
        toast.error("Some error occured")
      })
    }
  }
  
  return (
    <div
      className={`modal fade ${show ? "show" : "hide"}`}
      style={{ display: show ? "block" : "none" }}
      id="modal-lg"
      aria-modal="true"
      role="dialog"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Reset Password</h4>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" onClick={() => onClose()}>
                ×
              </span>
            </button>
          </div>
          <div className="modal-body">
            <div className="col-sm-12">
              {/* select */}
              {/* <div className="form-group">
                <label>UserName</label>
                <input
                  type="text"
                  name="username"
                  className="form-control"
                  id="username"
                  value={initialValues?.username}
                  // disabled
                  // defaultValue={loginId}
                   onChange={handleChange}
                />
              </div> */}
              <div className="form-group">
                <label>NewPassword</label>
                <div style={{ position: 'relative' }}>
                  <input
                    type={showNewPassword ? "password"  : "text" }
                    name="newpwd"
                    className="form-control"
                    id="newpwd"
                    value={initialValues?.newpwd}
                    onChange={handleChange}
                    style={{ paddingRight: '40px' }}
                  />
                  <span
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-60%)',
                      cursor: 'pointer',
                      fontSize: '18px',
                      color: '#6c757d'
                    }}
                  >
                    {showNewPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                  </span>
                </div>
              </div>
              <div className="form-group">
                <label>ConfirmPassword</label>
                <div style={{ position: 'relative' }}>
                  <input
                    type={showConfirmPassword ? "password"  : "text"}
                    name="cpassword"
                    className="form-control"
                    id="cpassword"
                    value={initialValues?.cpassword}
                    onChange={handleChange}
                    style={{ paddingRight: '40px' }}
                  />
                  <span
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-60%)',
                      cursor: 'pointer',
                      fontSize: '18px',
                      color: '#6c757d'
                    }}
                  >
                    {showConfirmPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer justify-content-between">
            <button
              type="button"
              className="btn btn-default"
              data-dismiss="modal"
              onClick={() => onClose()}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleSubmit()}
            >
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;